import { CONDICION_CLIENTE_EXTERIOR } from '@/features/contactos/constants';

/**
 * Ventas a clientes del exterior (Factura E, exportación): todas las líneas a
 * 0% de IVA. La Condición IVA del contacto vive en `CP_C`. El servidor aplica
 * la misma regla al guardar (server/src/lib/ventaExterior.ts); acá se refleja
 * en pantalla y en lo que se envía.
 */
export function esClienteExterior(condicionIva: string | null | undefined): boolean {
  return (condicionIva ?? '').trim() === CONDICION_CLIENTE_EXTERIOR;
}

/**
 * Líneas con la alícuota que corresponde al cliente. Para el exterior pone 0 en
 * todas; para uno local devuelve las líneas tal cual, así al volver a un cliente
 * local reaparece el IVA del artículo (la alícuota del artículo queda en `iva`
 * del borrador y esto sólo la oculta mientras el cliente sea del exterior).
 */
export function conIvaSegunCliente<T extends { iva: number }>(lines: T[], exterior: boolean): T[] {
  return exterior ? lines.map((l) => (l.iva === 0 ? l : { ...l, iva: 0 })) : lines;
}

/**
 * Alícuota a mandar al servidor. Una línea exenta de un cliente local sube al
 * default del país (la columna IVA_RO legacy no admite 0); la del exterior va en 0.
 */
export function ivaAEnviar(iva: number, exterior: boolean, ivaDefaultPais: number): number {
  if (exterior) return 0;
  return iva === 0 ? ivaDefaultPais : iva;
}

export const NOTA_EXPORTACION_SIN_IVA = 'Cliente del exterior: exportación sin IVA (Factura E)';
